// extracted by mini-css-extract-plugin
export default {"container":"AboutUs_container__EW4HN","heading":"AboutUs_heading__z+LLa","text":"AboutUs_text__Im1Dc"};